export default __webpack_public_path__ + "static/media/albertus_medium.883ba629.ttf";